import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import CategoryForm from "../../forms/CategoryForm";
import HotelForm from "../../forms/HotelForm";
import MainModal from "../../modals/MainModal";
import Main from "./Main";

const Banner = ({ setShow, show, isClicked, setIsClicked }) => {
  const [category, setCategory] = useState("");
  const location = useLocation();
  const scroll = useRef(null);
  const [modal, setModal] = useState("login");

  useEffect(() => {
    setCategory(location.pathname.split("/")[1]);
  }, [location]);

  useEffect(() => {
    scroll.current?.scrollIntoView({ behavior: "smooth" });
  }, [category]);

  return (
    <>
      <section
        className={
          category === "visa" || category === "insurance"
            ? "bf-hero dubai-visa-banner"
            : "bf-hero"
        }
      >
        <video id="myVideo" autoPlay muted loop>
          <source src="assets/video/banner.mp4" />
        </video>

        <div className="bf-hero-overlay"></div>

        <div className="bf-hero-container">
          <div className="bf-hero-content">
            <span className="bf-hero-eyebrow">Explore Amazing Destinations</span>

            <h1 className="bf-hero-title">
              Your Journey <span>Starts Here</span>
            </h1>

            <p className="bf-hero-subtitle">
              Hotels, Flights, Transfers, Car Rentals and Tours — everything
              you need for your next trip, in one place.
            </p>
          </div>

          <div className="bf-search-card" ref={scroll}>
            <Main
              setShow={setShow}
              isClicked={isClicked}
              setIsClicked={setIsClicked}
              setModal={setModal}
            />

            <CategoryForm category={category} setIsClicked={setIsClicked} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;